import { Cloudinary } from '@cloudinary/url-gen';
import { fill } from '@cloudinary/url-gen/actions/resize';
import { focusOn } from '@cloudinary/url-gen/qualifiers/gravity';
import { face } from '@cloudinary/url-gen/qualifiers/focusOn';
import type { App } from 'vue';

import { ENV } from '@/env';
import { cloudinaryKey } from '@/infra/injection-keys';

export { cloudinaryKey };

const cld = new Cloudinary({
  cloud: { cloudName: ENV.CLOUDINARY_NAME },
});

export function cloudinaryUrl(
  publicId: string,
  opts: { width: number; height: number },
): string {
  return cld
    .image(publicId)
    .resize(fill().width(opts.width).height(opts.height).gravity(focusOn(face())))
    .toURL();
}

export type CloudinaryHelper = typeof cloudinaryUrl;

export const cloudinaryPlugin = {
  install(app: App) {
    app.provide(cloudinaryKey, cloudinaryUrl);
  },
};
